import { Image as ChakraImage, forwardRef, ImageProps } from '@chakra-ui/react';

/**
 The Image component is used to display images with support for fallback.
 */
export const Image = forwardRef((props: ImageProps, ref) => {
  return <ChakraImage ref={ref} {...props} />;
});
